export default __webpack_public_path__ + "static/media/road_img_4_4.4a605817.jpg";